import { LitElement, html, utils } from '@hh/global.js'
const { toggle, reRenderShopifySections, addToCart } = utils

class HHGiftNote extends LitElement {

  connectedCallback() {
    super.connectedCallback()
    this.giftItemTextArea = this.querySelector('.mini-cart__gift-note-body-input textarea')
    this.giftItemCTA = this.querySelector('.mini-cart__gift-note-body-input button')
    this.addGiftItem()
  }

  onToggleGiftNote() {
    toggle(this.parentNode, ['mini-cart__footer--expanded'])
  }

  onValidateInput() {
    this.giftItemCTA.disabled = (this.giftItemTextArea.value === '') ? true : false
  }

  addGiftItem() {
    if (this.giftItemCTA && this.giftItemTextArea) {

      this.onValidateInput()

      const events = ['input', 'change', 'keyup']
      events.forEach(event => this.giftItemTextArea.addEventListener(event, this.onValidateInput.bind(this))
      )

      this.giftItemCTA.addEventListener('click', async (e) => {
        e.preventDefault()

        const giftProduct = this.giftItemCTA.dataset.gift
        const giftProductInCart = this.giftItemCTA.dataset.giftIncart
        const giftProductIndex = this.giftItemCTA.dataset.giftIndex

        if (giftProductInCart != "false") {
          this.dispatchEvent(
            new CustomEvent('updateGiftItem', {
              bubbles: true,
              composed: true,
              detail: {
                key: giftProductIndex,
                value: 1,
                note: this.giftItemTextArea.value.trim()
              }
            })
          )
        } else {
          this.dispatchEvent(
            new CustomEvent('addGiftItem', {
              bubbles: true,
              composed: true,
              detail: {
                key: giftProduct,
                value: this.giftItemTextArea.value.trim()
              }
            })
          )
        }
      });
    }
  }

  render() {
    return html`
    <div class="giftnote">
      <slot @toggleCart="${this.onToggleGiftNote}"></slot>
    </div>`
  }
}
customElements.define('hh-gift-note', HHGiftNote)
